import { STAGE_PRICING } from "@/data/stagePricing";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/analytics";

const PAGES = ["/tambours/editions-limitees", "/super-lune", "/offres/tambours-lieux-anciens", "/tambours-realises"];
const TO = "/offres/stage-fabrication-tambour#reserver";

export const StickyStageCta = () => {
  const { pathname } = useLocation();
  if (!PAGES.includes(pathname)) return null;
  const onClick = () => track("click_group_dates", { source: "sticky", page: pathname });
  return (
    <>
      <Link to={TO} onClick={onClick} data-testid="sticky-stage-cta-desktop"
        className="hidden lg:inline-flex fixed bottom-6 right-24 z-40 items-center gap-2 px-5 py-3 rounded-full bg-earth/90 backdrop-blur text-sand text-sm shadow-lg shadow-earth/20 hover:bg-terra hover:text-earth transition-colors duration-300">
        Réserver un stage <ArrowRight className="w-4 h-4" />
      </Link>
      <div className="lg:hidden fixed inset-x-0 bottom-0 z-40 pl-4 pr-24 pb-4 pt-6 bg-gradient-to-t from-sand via-sand/90 to-transparent pointer-events-none" data-testid="sticky-stage-cta-mobile">
        <Link to={TO} onClick={onClick} className="pointer-events-auto flex items-center justify-between gap-3 px-5 py-3.5 rounded-full bg-earth text-sand text-sm shadow-lg shadow-earth/25">
          <span>Créer mon tambour — dès CHF {STAGE_PRICING.groupe}.–</span><span className="inline-flex items-center gap-1.5 text-terra">Réserver <ArrowRight className="w-4 h-4" /></span>
        </Link>
      </div>
    </>
  );
};
